/**
 * A simple pub sub class
 */

class Radio {
  events: any;
  constructor() {
    this.events = {};
  }

  broadcast(event:string, data:any) {
    let self = this;
    if (!self.events.hasOwnProperty(event)) {
      return [];
    }

    return self.events[event].map((callback:any) => callback(data));
  }

  subscribe(event:string, callback:any) {
    let self = this;
    if (!self.events.hasOwnProperty(event)) {
      self.events[event] = [];
    }
    return self.events[event].push(callback);
  }
}

const radio = new Radio();

export function useRadio() {
  return radio;
}

